// extracted by mini-css-extract-plugin
var _1 = "SSOTab-module__animateUploadProgressBarWidth--ujZxB";
var _2 = "SSOTab-module__animatedBackground--CAYdA";
var _3 = "SSOTab-module__content--KpQJ_";
var _4 = "SSOTab-module__idpMetadata--kX2Zl";
var _5 = "SSOTab-module__title--_SQpb";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "content", _4 as "idpMetadata", _5 as "title" }
